import Vue from 'vue';
import Vuex from 'vuex';
import router from "../router";
import api from "../services/api";

Vue.use(Vuex);

const checkSegment = value => {
  return typeof value !== 'undefined' && value !== null
};

export default new Vuex.Store({
  state: {
    profileRequested: false,
    isLoading: false,
    isMenuOpened: false,
    showErrorsBag: false,
    errors: [],
    isAuthenticated: false,
    currentUser: false,
    smartCaptchaKey: '',
    segments: false,
    userBanned: false,
    userNonsmoking: false,
    deletionStatus: null,
    registrationIncomplete: false,
    incompleteStep: false,
    cigaretteMarks: null,
    userSegments: {
      alpha: false,
      betta: false,
    },
    currentSegments: {},
    ageConfirmed: false,
    showDocumentsTab: false,
    passportUploadedSuccessfully: null,
  },
  mutations: {
    loading(state, value) {
      state.isLoading = value;
    },
    setIsMenuOpened(state, value) {
      state.isMenuOpened = value;
    },
    setShowErrorsBag(state, value) {
      state.showErrorsBag = value;
    },
    setErrors(state, value) {
      if (value.length) {
        state.errors = value;
        state.showErrorsBag = true;
      }
    },

    login(state, data) {
      state.isAuthenticated = data['auth'] === 'Success' || data['SHOW_CONTENT'];
      state.deletionStatus = data['deletionRequestStatus'];

      if (state.segments) {
        state.userBanned =
          checkSegment(state.segments.BlockedCustomers) ||
          checkSegment(state.segments.DocumentsModerationFail)
      }
      state.showDocumentsTab = false;
      state.passportUploadedSuccessfully = null;
    },
    setInitialState(state) {
      state.profileRequested = false;
      state.isAuthenticated = false;
      state.userBanned = false;
      state.currentUser = false;
      state.segments = false;
      state.registrationIncomplete = false;
      state.incompleteStep = false;
      state.profileData = null;
      state.showDocumentsTab = false;
      state.passportUploadedSuccessfully = null;
    },
    setBeforeEachFirstRunDone(state, value = true) {
      state.isBeforeEachFirstRunDone = value;
    },
    setShowDocumentsTab(state, value) {
      state.showDocumentsTab = value;
    },
    setPassportUploadedSuccessfully(state, value) {
      state.passportUploadedSuccessfully = value;
    },
    setDeletionStatus(state, status) {
      state.deletionStatus = status;

      if (state.currentUser?.customFields) {
        state.currentUser.customFields.deletionRequestStatus = status;
      }
    },
    setUser(state, profileData) {
      state.currentUser = profileData;
    },
    setSmartCaptchaKey(state, key) {
      state.smartCaptchaKey = key;
    },
    setProfileDeletionDate(state, date) {
      if (state.currentUser?.customFields) {
        state.currentUser.customFields.deletionRequestDate = date;
      }
    },
    setStateData(state, data) {
      state[data.state] = data.data
    },
    setUserNonsmoking(state) {
      state.userBanned = true;
      state.userNonsmoking = true;
    },
    setSegments(state, segments) {
      state.segments = segments;
    },
    setAgeConfirmed(state, status) {
      state.ageConfirmed = status;
    }
  },
  actions: {
    // UI
    showLoader({commit}) {
      commit('loading', true);
    },
    hideLoader({commit}) {
      commit('loading', false);
    },

    toggleMenu({state, commit}) {
      commit('setIsMenuOpened', !state.isMenuOpened);
    },
    showErrorsBag({commit}) {
      commit('setShowErrorsBag', true);
    },
    hideErrorsBag({commit}) {
      commit('setShowErrorsBag', false);
    },
    setShowDocumentsTab({commit}, value) {
      commit('setShowDocumentsTab', value);
    },
    setPassportUploadedSuccessfully({commit}) {
      commit('setPassportUploadedSuccessfully', true);
    },
    setErrors({commit}, errors) {
      let messages;
      if (
        typeof errors.errors !== 'undefined'
        && typeof errors.errors[0] !== 'undefined'
      ) {
        if (errors.errors[0].code === 0) {
          messages = [errors.errors[0].message];
        } else {
          messages = errors.errors[0].customData || [errors.errors[0].message];
        }
        commit('setErrors', messages);
      }
    },
    clearErrors({commit}) {
      commit('setErrors', []);
    },
    confirmAge({ commit }) {
      commit('setAgeConfirmed', true);
    },

    async setSegments({ commit }, segments ) {
      commit('setSegments', segments);
    },
    resetAgeConfirmation({ commit }) {
      commit('setAgeConfirmed', false);
    },
    async gohome() {
      await router.push({name: 'home'});
    },
    async goblocked() {
      await router.push({name: 'blocked'});
    },
    async goprofileupdate() {
      await router.push({name: 'profile-update'});
    },
    async goProfileForm() {
      await router.push({name: 'profile-fields'});
    },
    async goToInfoAboutPassportCheck(text) {
      await router.push({name: 'info-passport-check', params: {text: text}});
    },

    // User management
    // eslint-disable-next-line
    async login({dispatch, commit, state}, credentials) {
      const data = await api.login(credentials);

      if (data) {
        await dispatch('checkAuthentication');
        commit('setUser', data.user);
        // TODO - активировать после того, как через checkAuthentication будет приходить сегмент needPassport
        // commit('setSegments', data.segments);
        if (data.auth === 'Success') {
          state.isAuthenticated = true;
        }

        /*if (result.segments && (
          checkSegment(result.segments.RegistrationStage2) ||
          checkSegment(result.segments.RegistrationStage2per) ||
          checkSegment(result.segments.DocumentsModerationInProcess))
        ) {
          let res = await api.simplePostRequest('/api/getRegistrationStep');
          state.registrationIncomplete = true;
          state.incompleteStep = res;
        }*/
        commit('login', data);
        return data;
      }
    },
    async checkAuthentication({dispatch, commit, state}) {
      const data = await api.checkAuthentication();
      if (data) { // запущена сессия, отдается профиль пользователя и сегменты
        if (data.user) {
          await dispatch('fetchUserSegments');
          commit('setUser', data.user);
        }

        if (data.smartCaptchaKey) {
          commit('setSmartCaptchaKey', data.smartCaptchaKey);
        }

        // TODO - активировать после того, как через checkAuthentication будет приходить сегмент needPassport
        // commit('setSegments', data.segments);
        if (data.auth === 'Success') {
          state.isAuthenticated = true;
        }
      }
    },
    async logout({commit}, logoutUrl) {
      if (logoutUrl) {
        await api.logout(logoutUrl);
      }
      commit('setInitialState');
      if (router.currentRoute.name !== 'login') {
        await router.push('/login');
      }
    },
    async segmentsJump({state, dispatch}, step = false) {
      const segments = state.segments;
      const canShowConsumption = state.currentUser.canShowConsumption || true;

      //if (checkSegment(segments.RegistrationStage2DocumentsFirst) || checkSegment(segments.RegistrationStage2DocumentsFirst)) {

      //}

      if (checkSegment(segments.alpha)) {
        dispatch('goprofileupdate');
        return;
      }

      if (checkSegment(segments.CheckConsumptionPart1) && canShowConsumption) {
        await router.push({name: 'consumption-survey'});
        return;
      }
      //if (checkSegment(segments.CheckConsumptionPart2) && canShowConsumption) {
        // await router.push({name: 'consumption-survey', params: {initStep: 'step2'}});
        // return;
      // }
      if (
        checkSegment(segments.BlockedCustomers) ||
        checkSegment(segments.DocumentsModerationFail)
      ) {
        await router.push({name: 'blocked'});
        return;
      }
      if (checkSegment(segments.DocumentsModerationResend)) {
        if (step) {
          await router.push({name: 'register', params: {step: 2, redirect: step}});
          return;
        } else {
          await router.push({name: 'register', params: {step: 2}});
          return;
        }
      }
      if (checkSegment(segments.DocumentsModerationInProcess)) {
        if (checkSegment(segments.RegistrationStage2)) {
          await router.push({name: 'register', params: {step: step || 8}});
          return;
        } else {
          dispatch('gohome');
        }
      }
      if (checkSegment(segments.DocumentsModerationSuccess)) {
        dispatch('gohome');
      }

      dispatch('gohome');
    },
    async fetchProfile({commit, dispatch}) {
      dispatch("showLoader");
      try {
        const profileData = await api.fetchProfile();
        if (profileData) {
          commit('setUser', profileData);
        }
      } catch (e) {
        /*
          api.fetchProfile() обрабатывает все ошибки внутри, а возвращает только false поэтому данный блок не выполняется
         */
        dispatch('gohome');
      } finally {
        dispatch("hideLoader");
      }
    },
    async fetchCigaretteMarks({commit, dispatch}) {
      dispatch("showLoader");
      try {
        const result = await api.fetchCigaretteMarks();

        if (result) {
          commit('setStateData', {state: 'cigaretteMarks', data: result});
        }
      } catch (e) {
        dispatch('setErrors', e);
      } finally {
        dispatch("hideLoader");
      }
    },
    async fetchUserSegments({commit, dispatch}) {
      try {
        const userSegments = await api.simplePostRequest('/api/checkSegmentations');

        if (userSegments) {
          commit('setSegments', userSegments);
        }

        return userSegments
      } catch (e) {
        dispatch('setErrors', e);
      }
    },
    async showBlockOnBoarding({dispatch}) {
      try {
        await api.simplePostRequest('/api/showBlockOnBoarding');
      } catch (e) {
        dispatch('setErrors', e)
      }
    },
    async deleteProfile({commit, dispatch}) {
      dispatch("showLoader");
      try {
        const result = await api.simplePostRequest('/api/deletion');
        const deletionDate = result.deletionRequestDate;
        commit('setProfileDeletionDate', deletionDate);
        commit('setDeletionStatus', true);
      } catch (e) {
        dispatch('setErrors', e);
      }
      dispatch("hideLoader");
    },
    async deletionRecall({commit, dispatch}) {
      dispatch("showLoader");
      try {
        await api.simplePostRequest('/api/deletionRecall');
        commit('setProfileDeletionDate', null);
        commit('setDeletionStatus', false);
      } catch (e) {
        dispatch('setErrors', e);
      } finally {
        dispatch("hideLoader");
      }
    },
  },
  getters: {
    isAgeConfirmed: (state) => state.ageConfirmed,
    isDocumentsTabVisible: (state, getters) => {
      return !getters.isAuthenticated
    },
    isStandardLinkVisible: (state, getters) => {
      return state.segments?.TRADE || getters.isAuthenticated
    },
    isUserBanned: (state) => {
      checkSegment(state.segments.BlockedCustomers) ||
      checkSegment(state.segments.DocumentsModerationFail)
    },
    profileFetched: (state) => {
      return Boolean(state.currentUser);
    },
    needPassport: state => {
      return state.segments?.needPassport;
      // return Boolean(state.segments?.RegistrationStage2DocumentsFirst) ||
      // Boolean(state.segments?.RegistrationStage2DocumentsNew) ||
      // Boolean(state.segments?.RegistrationStage2per)
    },
    deletionDate: (state) => {
      return state.currentUser?.customFields?.deletionRequestStatus
        && state.currentUser?.customFields?.deletionRequestDate
    },
    isPassportBeingProcessed: state => {
      return !state.segments?.needPassport &&
        (
          Boolean(state.segments?.RegistrationStage2per) ||
          Boolean(state.segments?.RegistrationStage2)
        )
    },
    isAuthenticated: state => state.isAuthenticated,
    accessType: (state, getters) => {
      return getters.profileFetched ?
        getters.isAuthenticated ? 'authenticated' : 'unauthenticated' :
        'signed-out'
    },
    isSegmentTrade: (state) => {
      return Boolean(state.segments?.TRADE)
    },
    userType: (state, getters) => {
      if (state.segments?.ProductSiteOnly) {
        return 'products-only'
      } else if (getters.isSegmentTrade) {
        return 'trade'
      } else {
        return 'default'
      }
    }
  },
  modules: {
  },
  plugins: [
  ]
})
